import importerStore from '@shared/importer/importer-store';
import { SheetEventService } from '@modules/sheet-event/sheet-event-service';
import sheetEventImporterFields from '@modules/sheet-event/sheet-event-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  SheetEventService.import,
  sheetEventImporterFields,
  i18n('entities.sheetEvent.importer.fileName'),
  i18n('entities.sheetEvent.importer.hint'),
);
